/** Left-panel copy shared by the sign-in and beta sign-up pages, so the two cannot drift. */
export const AUTH_HEADLINE = (
  <>
    Code faster.
    <br />
    Ship with AI agents.
  </>
);

export const AUTH_FEATURES = [
  {
    title: 'AI Agents Built In',
    description: 'Agents that code, review, and ship alongside you',
    icon: 'robot' as const,
  },
  {
    title: 'Projects + Code + Deploy',
    description: 'Everything centralized — no more tab hopping',
    icon: 'grid' as const,
  },
  {
    title: 'Instant Workspaces',
    description: 'Go from idea to running code in seconds',
    icon: 'lightning' as const,
  },
];
